module.exports = __webpack_public_path__ + "img/actalentpool.185296bd.svg";